"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorBoundary = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
class ErrorBoundary extends react_1.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }
    componentDidCatch(error, errorInfo) {
        console.error('ErrorBoundary caught an error:', error, errorInfo);
        this.props.onError?.(error, errorInfo);
    }
    render() {
        if (this.state.hasError) {
            return this.props.fallback || ((0, jsx_runtime_1.jsxs)("div", { className: "flex min-h-[400px] flex-col items-center justify-center p-8 text-center", children: [(0, jsx_runtime_1.jsx)("div", { className: "mb-4 text-6xl", children: "\uD83D\uDE15" }), (0, jsx_runtime_1.jsx)("h2", { className: "mb-2 text-xl font-semibold text-gray-900", children: "Something went wrong" }), (0, jsx_runtime_1.jsx)("p", { className: "mb-4 text-gray-600", children: "We're sorry, something unexpected happened. Please try refreshing the page." }), (0, jsx_runtime_1.jsx)("button", { onClick: () => window.location.reload(), className: "rounded-md bg-stone-900 px-4 py-2 text-white", children: "Refresh page" }), process.env.NODE_ENV === 'development' && this.state.error && ((0, jsx_runtime_1.jsxs)("details", { className: "mt-4 w-full max-w-md", children: [(0, jsx_runtime_1.jsx)("summary", { className: "cursor-pointer text-sm text-gray-500", children: "Error details" }), (0, jsx_runtime_1.jsx)("pre", { className: "mt-2 whitespace-pre-wrap text-left text-xs text-red-600", children: this.state.error.stack })] }))] }));
        }
        return this.props.children;
    }
}
exports.ErrorBoundary = ErrorBoundary;
